import { mutationTypes } from '@/types';
import { syncActionStates } from '@/tools/consts';

export default {
	/**
	 * This mutations sets app into syncer mode
	 * @param { } state
	 */
	[mutationTypes.packageSyncerSetIsSyncerApp](state, { mode }) {
		state.isSyncerApp = true;
		state.mode = mode;
	},
	/**
	 *	Sets already installed packages
	 * @param { * } state
	 * @param { packages } packages
	 */
	[mutationTypes.setOfflineAvailablePackages](state, { packages }) {
		state.offlineAvailablePackages = packages;
		state.offlineAvailablePackagesIndex = new Set(packages.map(({ name }) => name));
	},

	/**
	 * This mutation commited by native package syncer progress event
	 * @param { } state
	 * @param { appsProcessed, appsTotal, error } progress informations
	 */
	[mutationTypes.packageSyncerSetProgress](state, { appsProcessed, appsTotal, error }) {
		state.packagesProcessed = appsProcessed;
		state.packagesTotal = appsTotal;
		state.error = error;
	},
	[mutationTypes.packageSyncerSetSubPartState](state, { subPartId, subPartState }) {
		if ([syncActionStates.loading, syncActionStates.deleting].includes(subPartState)) {
			state.activeSubPartId = subPartId;
		} else if (state.activeSubPartId === subPartId) {
			state.activeSubPartId = null;
		}
		state.subPartStates[subPartId] = subPartState;
		state.subPartStates = Object.assign({}, state.subPartStates);
	},
	[mutationTypes.packageSyncerPushError](state, error) {
		state.errors.push(error);
	},
	[mutationTypes.packageSyncerClearErrors](state) {
		state.errors = [];
	},
};
